import React, { Component }from 'react';
import HttpUtil from '../commonjs/httpUtil';
import $ from 'jquery';
import Method from '../commonjs/comModule';
import RequestUrl from '../commonjs/urlConfiger';
import  '../css/firstScreen.css';
const maxFonst = 100;
export default class Cascade extends Component{
    constructor(props) {
            super(props);
            this.state = {
              data:[],
              pages:"1",//页数
              pos:this.props.msg,
              refresh:false//减少子组件刷新次数
            };
    }
    componentWillMount() { //组件初始化时只调用，以后组件更新不调用，整个生命周期只调用一次，此时可以修改state。

    }
    shouldComponentUpdate(nextProps, nextState) {//componentWillReceiveProps方法中第一个参数代表即将传入的新的Props

        if (nextState.refresh){
            return true;
        }

        return false;
    }
    componentDidMount() {//组件渲染之后调用，只调用一次。

      this.h5PageList(this.props.msg.id,this.state.pages);
    }
    h5PageList = (id,pages) =>{
     HttpUtil.getP(RequestUrl.h5PageList(id,pages)).then((json) => {

        if(json.code === "A000000" && typeof json){
           let total = json.data.total;//总条数
           let pageSize = json.data.pageSize;//每页的条数
           let pages = Math.ceil(total / pageSize);//计算出的总条数
           let currentPages = parseInt(this.state.pages);//当前的页数

          if(currentPages < pages ){

            this.setState({pages:currentPages+1,data:this.state.data.concat(json.data.list),refresh:true});
            this.h5PageList(this.props.msg.id,this.state.pages);
          }else{
            this.setState({data:this.state.data.concat(json.data.list),refresh:true});
          }

          this.props.comReRender.reRender();
        }

      },()=>{
        this.props.errorTipsCom("tips","网络链接失败，请稍后再试！");
      });

    }
    render(){
      const {data,pos} = this.state;
      const maxTop = 39;
        return(
            <div>
              {
                  data && data.map((key,i)=>{
                    //除了六列圆版的，其他七个都是：距左128px，距右127px   六列圆版的左右都是：155px
                    let styles = {
                        top:pos.posY / maxFonst +"rem",
                        width:(key.width+3) / maxFonst +"rem",
                        height:key.height / maxFonst +"rem",
                        left:(key.fixedModelType==5?"1.55":"1.28")+"rem",
                    };

                    return(
                      <div key={i} style={styles} className="topic-list" >
                              { key.defineInfo.map((val,j)=>{
                                  //比如baseSizeX=1 那宽度就是387px; baseSizeX=2 那宽度就是387*2px;
                                 let less = {
                                    marginRight:!Method.isInteger(j+1,key.cols)?key.paddingX/maxFonst+"rem":"",
                                    width:(key.baseSizeX*val.posWidth) / maxFonst + "rem",
                                    height:(key.baseSizeY*val.posHeight) / maxFonst + "rem",
                                    borderRadius:key.fixedModelType==5?((key.baseSizeY*val.posHeight) / maxFonst)/2+"rem" :"",
                                    background:"url("+val.appInfos[0].contentPic+") no-repeat",
                                    backgroundSize:"100% 100%",
                                  }
                                  let mbDrift = {//位移图样式
                                    marginRight:!Method.isInteger(j+1,key.cols)?key.paddingX/maxFonst+"rem":"",
                                    width:(key.baseSizeX*val.posWidth) / maxFonst + "rem",
                                    height:(key.baseSizeY*val.posHeight + maxTop) / maxFonst + "rem",
                                    position: "absolute",
                                     top: "-.4rem",
                                    borderRadius:key.fixedModelType==5?((key.baseSizeY*val.posHeight) / maxFonst)/2+"rem" :"",
                                    background:"url("+val.appInfos[0].contDriftPic+") no-repeat",
                                    backgroundSize:"100% 100%",
                                  };

                                  return (
                                    <div className="topic-drift" key={j+"J"}>
                                        <div key={j} data-width={(key.baseSizeX*val.posWidth)} data-height={(key.baseSizeY*val.posHeight)}  data-border={this.props.msg.borderColor} data-cont={val.appInfos[0].isDisplayContDriftPic} data-contid={val.appInfos[0].cpContentId} data-positionName={val.appInfos[0].contentName} data-contentId={this.props.pbJson.screeninfo.contentId} data-num = {this.props.pbJson.screeninfo.contentId+"020"+this.props.pageNum+"0"+(j+1)} style={less} data-info={JSON.stringify(val.appInfos[0].appInfo)} data-role="Widget" className="topic-key">
                                            {val.appInfos[0].isDisplayContDriftPic != 0 ? <div  key={j+"Y"} className="topic-dis topic-driftPic" style={mbDrift}></div> : ""}
                                        </div>

                                    </div>
                                  )
                                })
                              }
                      </div>
                    )
                  })
                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/cascade.js